import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { useUnitsAfterState, useUnitsBeforeState } from 'app-components/hooks/investment-forms';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';

const InvestmentTransactionStockSplitForm = (props) => {
  const { formik } = props;

  useEffect(() => {
    formik.registerField('splitNumerator', {
      validate: (value) => (typeof value === 'number' && value ? undefined : 'use valid number'),
    });
    formik.registerField('splitDenominator', {
      validate: (value) => (typeof value === 'number' && value ? undefined : 'use valid number'),
    });
    return () => {
      formik.unregisterField('splitNumerator');
      formik.unregisterField('splitDenominator');
    };
  }, [formik]);

  const [unitsBefore, setUnitsBefore] = useUnitsBeforeState(formik);
  const [unitsAfter, setUnitsAfter] = useUnitsAfterState(formik);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex' gap={3} flexDirection='column'>
        <Box display='flex' alignItems='center' gap={1}>
          <TextField
            id='split-numerator'
            label='Post Split'
            type='number'
            inputProps={{ min: 1 }}
            sx={{ minWidth: 110 }}
            value={formik.values.splitNumerator}
            onChange={(event) =>
              formik.setFieldValue('splitNumerator', event.target.value ? Math.abs(Number(event.target.value)) : null)
            }
            error={Boolean(formik.submitCount > 0 && formik.errors.splitNumerator)}
            helperText={(formik.submitCount > 0 && formik.errors.splitNumerator) || ''}
          />
          :
          <TextField
            id='split-denominator'
            label='Pre Split'
            type='number'
            inputProps={{ min: 1 }}
            sx={{ minWidth: 110 }}
            value={formik.values.splitDenominator}
            onChange={(event) =>
              formik.setFieldValue('splitDenominator', event.target.value ? Math.abs(Number(event.target.value)) : null)
            }
            error={Boolean(formik.submitCount > 0 && formik.errors.splitDenominator)}
            helperText={(formik.submitCount > 0 && formik.errors.splitDenominator) || ''}
          />
        </Box>

        <Box display='flex' alignItems='center' gap={1}>
          <TextField
            id='units-after'
            label='Units After Split'
            type='number'
            inputProps={{ min: 1 }}
            sx={{ minWidth: 110 }}
            disabled={formik.values.splitNumerator === formik.values.splitDenominator}
            value={unitsAfter}
            onChange={(event) => setUnitsAfter(event.target.value === '' ? null : Number(event.target.value))}
          />
          -
          <TextField
            id='units-before'
            label='Units Before Split'
            type='number'
            inputProps={{ min: 1 }}
            sx={{ minWidth: 110 }}
            disabled={formik.values.splitNumerator === formik.values.splitDenominator}
            value={unitsBefore}
            onChange={(event) => setUnitsBefore(event.target.value === '' ? null : Number(event.target.value))}
          />
          =
          <TextField
            id='units'
            label='Shares adjustment'
            type='number'
            editable
            disabled
            sx={{ minWidth: 110 }}
            value={
              formik.values.splitNumerator !== formik.values.splitDenominator && formik.values.units != null
                ? Math.abs(formik.values.units)
                : ''
            }
          />
        </Box>
      </Box>
    </>
  );
};

InvestmentTransactionStockSplitForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default InvestmentTransactionStockSplitForm;
